// setPrototypeOf in constructors (see below) fixes prototype chain: https://goo.gl/0YcFxB
import setPrototypeOf from 'setprototypeof';
export class ServiceError extends Error {
    constructor(status, service, message, response) {
        super(message);
        setPrototypeOf(this, ServiceError.prototype);
        this.status = status;
        this.service = service;
        this.response = response;
    }
}
export class ServiceTimeoutError extends ServiceError {
    constructor(service, message) {
        super(408, service, message);
        setPrototypeOf(this, ServiceTimeoutError.prototype);
    }
}
export class NotFoundError extends ServiceError {
    constructor(status, service, message, response) {
        super(status, service, message, response);
        setPrototypeOf(this, NotFoundError.prototype);
    }
}
export class BadGatewayError extends ServiceError {
    constructor(status, service, message, response) {
        super(status, service, message, response);
        setPrototypeOf(this, BadGatewayError.prototype);
    }
}
export class DataversionInvalidError extends ServiceError {
    constructor(status, service, message) {
        super(status, service, message);
        setPrototypeOf(this, DataversionInvalidError.prototype);
    }
}
export class ResponseParsingError extends ServiceError {
    constructor(status, service, message, response) {
        super(status, service, message, response);
        setPrototypeOf(this, ResponseParsingError.prototype);
    }
}
export async function dataversionUpdateHandler(callApi, url, service, options) {
    try {
        return await callApi(url, service, options);
    }
    catch (error) {
        if (error instanceof NotFoundError) {
            throw new DataversionInvalidError(error.status, error.service, error.message);
        }
        throw error;
    }
}
export class ConfigurationInvalidServiceError extends ServiceError {
    constructor(status, service, message) {
        super(status, service, message);
        setPrototypeOf(this, ConfigurationInvalidServiceError.prototype);
    }
}
export async function configurationInvalidHandler(callApi, url, service, options) {
    try {
        return await dataversionUpdateHandler(callApi, url, service, options);
    }
    catch (error) {
        if (error instanceof ServiceError && error.status === 500) {
            // we assume it is a non-buildable configuration
            throw new ConfigurationInvalidServiceError(error.status, error.service, error.message);
        }
        throw error;
    }
}
